module.exports = __webpack_public_path__ + "img/history@2x.a4e94f1f.png";